// @flow

import * as React from "react"
import {withTranslation} from "react-i18next"
import type {
  ProductCategory,
  BabyListOptionalItem,
  Product,
  ProductSet,
} from "../types"
import {NavLink, withRouter} from "react-router-dom"

type Props = {
  +categories: $ReadOnlyArray<ProductCategory>,
  +optionals: $ReadOnlyArray<BabyListOptionalItem>,
  +laters: $ReadOnlyArray<Product | ProductSet>,
  +match: any,
  t: any,
}

class ProductCategoryNav extends React.Component<Props> {
  render() {
    const {
      categories,
      t,
      match: {
        params: {babyToken},
      },
      optionals,
      laters,
    } = this.props
    return (
      <div className="product-category-nav">
        <ul>
          {categories
            .filter((cat) => cat.id && cat.productCount && cat.productCount > 0)
            .map((cat) => (
              <li key={`cat-nav-${cat.id}`}>
                <NavLink
                  to={`/intake/${babyToken}/categories/${cat.id}`}
                  activeClassName="is-active"
                >
                  {cat.name}
                </NavLink>
              </li>
            ))}
          {optionals.length > 0 ? (
            <li key={`cat-nav-optionals`} className="virtuals">
              <NavLink
                to={`/intake/${babyToken}/categories/optionals`}
                activeClassName="is-active"
              >
                {t("intake.nav.optionals")}
              </NavLink>
            </li>
          ) : null}
          {laters.length > 0 ? (
            <li key={`cat-nav-laters`} className="virtuals">
              <NavLink
                to={`/intake/${babyToken}/categories/laters`}
                activeClassName="is-active"
              >
                {t("intake.nav.laters")}
              </NavLink>
            </li>
          ) : null}
        </ul>
      </div>
    )
  }
}

export default withTranslation()(withRouter(ProductCategoryNav))
